import React, { useContext } from 'react';

const YWebsocketContext = React.createContext({
    url: 'http://localhost:1234',
    jwt: null
});

export default function useYWebsocketContext() {
    return useContext(YWebsocketContext);
}

export { YWebsocketContext };



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useYWebsocketContext.js